const GeneralBookingSettingMixin = {
    mounted(){
        // this.$store.dispatch('setActiveMultipleServiceBookingSetting')
    },
	computed: {
        generalBookingSetting() {
            return this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_BOOKING_SETTING;
        },
		printBookingHistoryBtnText() {
            return this.TEXTS.render(`ADDRESS_PIN_BTN_BOOKING_HISTORY`, this.isEnabledBinCollection ? `binCollection` : `default`, null, {skipCasing:true});
        },
		pinnedAddressBookingHistoryBtnText() {
            return this.TEXTS.render(`ADDRESS_PIN_BTN_BOOKING_HISTORY`, this.isEnabledBinCollection ? `moreDetails` : `default`, null, {skipCasing:true});
        },
        isEnabledBinCollection() {
        	return this.generalBookingSetting && this.generalBookingSetting.enable_bin_collection;
        },
        siteWording() {
            return this.$store.getters.GET_SITE_WORDINGS.booknow_button_label;
        }
	}
};

module.exports = GeneralBookingSettingMixin;